import React from 'react';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import { HeaderWithButtonWrapper } from 'src/domains/layouts/shared/cms/list/List.style';
import { ContentH3 } from 'src/domains/layouts/shared/typography/Content.style';
import { observer } from 'src/utils/mobx-react';
import { PlusIconWrapper } from '../CategoriesPage.style';

interface PropsType {
    pageTitle: string,
    hasButton: boolean,
    onClick?: () => void
}

export const PageHeader = observer('PageHeader', (props: PropsType) => {
    const { pageTitle, hasButton, onClick } = props;

    return (
        <HeaderWithButtonWrapper>
            <ContentH3>{ pageTitle }</ContentH3>
            { hasButton ?
                <Button
                    onClick={onClick}
                    dataTest='create-new-category-button'
                >
                    <PlusIconWrapper />
                    Create new category
                </Button> :
                null
            }
        </HeaderWithButtonWrapper>
    );
});
